;(async () => {
  const { default: Vue } = await import('vue')
  await import('./plugins/vueApollo')
  await import('./plugins/vuetify')
  await import('./plugins/vueAxios')
  const { default: vuetify } = await import('./plugins/vuetify')
  const { default: App } = await import('./App.vue')
  const { default: store } = await import('@/config/store/store')
  const { default: router } = await import('@/config/router/router')
  await import('./domains')
  const { addDomains } = await import('@/config/domainRegistry')
  const { FontAwesomeIcon } = await import('@fortawesome/vue-fontawesome')
  const { faBell, faSync } = await import('@fortawesome/free-solid-svg-icons')
  const { library } = await import('@fortawesome/fontawesome-svg-core')
  const { createProvider } = await import('@/config/domainRegistry/apollo')
  await addDomains().then(() => {
    library.add(faSync)
    library.add(faBell)

    Vue.component('font-awesome-icon', FontAwesomeIcon)
    Vue.config.productionTip = false
    new Vue({
      router,
      apolloProvider: createProvider(),
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
  })
})()
